import type { ActionFunctionArgs } from 'react-router';

import { LOGIN_URI } from '@/common/constants/config';

export const loginAction = () => {
  return async (args: ActionFunctionArgs) => {
    const formData = await args.request.formData();
    const returnTo = formData.get('returnTo');
    const sessionUrl = `${window.location.origin}/session`;

    const returnUrl = (() => {
      const url = new URL(sessionUrl);

      if (typeof returnTo === 'string' && returnTo.startsWith('/')) {
        url.searchParams.set('returnTo', returnTo);
      }

      return url.toString();
    })();

    const params = new URLSearchParams({ returnUrl });

    location.assign(`${LOGIN_URI}?${params.toString()}`);
  };
};
